import React from "react";
import css from './CardETFsEvents.css'
import PropTypes from 'prop-types';

export default function CardETFsEvents(props) {

  return (
    <div className={css.card}>
      <img className={css.image} src={props.image} alt="" />
      <div className={css.content}>
        <a href={props.src} target="_blank" rel="noopener noreferrer">
          <span className={css.title}>{props.title}</span>
        </a>
        <p className={css.desc}>{props.description}</p>
        <div className={css.action_container}>
          <a className={css.action} href={props.src} target="_blank" rel="noopener noreferrer">
            {props.buttonText}
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  )
}

CardETFsEvents.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    src: PropTypes.string
}
